<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="rateBuckets" dataKey="rateBucketId" (onEditInit)="onCellEditInit($event)"
  (onEditComplete)="onCellEditComplete($event)" (onEditCancel)="onCellEditCancel()" [lazy]="false"
  [totalRecords]="recordTotal" [paginator]="true" [rows]="rows" [showCurrentPageReport]="true" [(first)]="first"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="[10,50,100]"
  [responsive]="true" sortMode="multiple" [multiSortMeta]="multiSortMeta"
  [globalFilterFields]="['name','description']" styleClass="p-datatable-striped" [style]="{'width':'100%'}">
  <ng-template pTemplate="caption">

    <table style="width:100%">
      <tr>
        <td style="white-space:nowrap;"><b>Rate Buckets</b></td>
        <td style="width:100%;text-align: right">
          <button mat-button style="color:green" (click)="onOpenFormAdd()">
            <mat-icon style="font-size:140%">add_circle</mat-icon> Add Rate Bucket
          </button>
          <input pInputText type="text" (input)="pt.filterGlobal($event.target.value, 'contains')"
            placeholder="Search" />
        </td>
      </tr>
    </table>

  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    <tr>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th>
        <input pInputText type="text" (input)="pt.filter($event.target.value, 'name', 'contains')"
          placeholder="Filter by Name" class="p-column-filter">
      </th>
      <th>
        <input pInputText type="text" (input)="pt.filter($event.target.value, 'description', 'contains')"
          placeholder="Filter by Description" class="p-column-filter">
      </th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rateBucket>
    <tr [pEditableRow]="rateBucket">
      <td>{{rateBucket.rateBucketId}} </td>
      <td [pEditableColumn]="rateBucket" [pEditableColumnField]="'name'">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText type="text" [(ngModel)]="rateBucket.name">
          </ng-template>
          <ng-template pTemplate="output">
            {{rateBucket.name}}
          </ng-template>
        </p-cellEditor>
      </td>
      <td [pEditableColumn]="rateBucket" [pEditableColumnField]="'description'">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText type="text" [(ngModel)]="rateBucket.description" required>
          </ng-template>
          <ng-template pTemplate="output">
            {{rateBucket.description}}
          </ng-template>
        </p-cellEditor>
      </td>

      <td>{{rateBucket.createDate | date:'M-d-yy' }} </td>
      <td>{{rateBucket.lastUpdate | date:'M-d-yy' }} </td>
      <td><span style="float:none">
        <!--
        Row Editing Features
        <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow icon="use-mat-icon-instead" (click)="onRowEditInit(rateBucket)" class="p-button-rounded p-button-text">
          <mat-icon>edit</mat-icon>
        </button>
        <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" (click)="onRowEditSave(rateBucket)" class="p-button-rounded p-button-text p-button-success mr-2"></button>
        <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onRowEditCancel(rateBucket, ri)" class="p-button-rounded p-button-text p-button-danger"></button> -->


        <a>
          <mat-icon style="color:blue; font-size:110%; padding-right:20px;"
          (click)="onOpenFormEdit(rateBucket)">edit</mat-icon>
        </a>&nbsp;&nbsp;
        <a>
          <i class="pi pi-copy ml-8" style="color:green; font-size:110%; padding-right:20px;"
          (click)="onOpenFormCopy(rateBucket)"></i>
        </a>
        <!-- a>
        <mat-icon style="color:red; font-size:110%; padding-left:20px;" (click)="onRowDelete(rateBucket)">delete</mat-icon>
      </a> -->
    </span>
  </td>
</tr>
</ng-template>
</p-table>